/**
 * Configurazione del sito istituzionale a cui la tab dà accesso.
 */

export const DEFAULT_SITE_URL = 'https://eneait.sharepoint.com/sites/IntraENEA';
export const DEFAULT_SITE_NAME = 'Sito istituzionale ENEA';

/** Configurazione risolta a runtime. */
export interface SiteConfig {
  url: string;
  name: string;
  /** Nome dell'ente mostrato come sottotitolo. */
  organisation: string;
}

/** true se la stringa è un URL http/https assoluto. */
export function isValidExternalUrl(raw: string): boolean {
  try {
    const u = new URL(raw.trim());
    return u.protocol === 'https:' || u.protocol === 'http:';
  } catch {
    return false;
  }
}

/**
 * Risolve l'URL del sito: usa quello passato se valido, altrimenti il default.
 * Un valore non valido non deve mai finire nel manifest o in un link.
 */
export function resolveSiteUrl(raw: string | undefined | null): string {
  const candidate = (raw ?? '').trim();
  return isValidExternalUrl(candidate) ? candidate : DEFAULT_SITE_URL;
}

/** Costruisce la configurazione a partire dalle variabili d'ambiente. */
export function loadSiteConfig(
  env: Record<string, string | undefined> = import.meta.env as unknown as Record<
    string,
    string | undefined
  >,
): SiteConfig {
  return {
    url: resolveSiteUrl(env.VITE_SITE_URL),
    name: (env.VITE_SITE_NAME ?? DEFAULT_SITE_NAME).trim() || DEFAULT_SITE_NAME,
    organisation: (env.VITE_ORGANISATION ?? 'ENEA').trim() || 'ENEA',
  };
}
